import api from '@/services/api'

export const getTemplatesFromApi = async () => {
    try {
        const resp = await api.get('templates', {
            params: { with: 'askings' },
        })

        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const createTemplate = async data => {
    try {
        const resp = await api.post('templates', data)
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const updateTemplate = async (id, data) => {
    try {
        const resp = await api.put(`templates/${id}`, data)
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const deleteTemplate = async id => {
    try {
        const resp = await api.delete(`templates/${id}`)

        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}
